module.exports = __webpack_public_path__ + "static/media/entertain-kung-fu.84e01e64.mp4";